import React, {
  useState
} from 'react';
import PropTypes from 'prop-types';
import ListItemText from '@material-ui/core/ListItemText';
import Avatar from '@material-ui/core/Avatar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import DeleteIcon from '@material-ui/icons/Delete';
import Chip from '@material-ui/core/Chip';
import Link from '@material-ui/core/Link';
import { withStyles } from '@material-ui/core/styles';
import { packageOptions } from '~/config/customQuery/userConfig';
import { URL } from '~/config/uri';
import { showPerson } from '~/config/routes';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import SettingsIcon from '@material-ui/icons/Settings';
import SendIcon from '@material-ui/icons/Send';
import Menu from '@material-ui/core/Menu';
import Can from '~/contexts/Can';

const DependentPackages = ({packages}) =>
  packages.map( (p) =>
    <Chip key={p.id} label={packageOptions[p.pack_type]} size="small" component='span'/>
  );

const StyledMenu = withStyles({
  paper: {
    border: '1px solid #d3d4d5',
  },
})((props) => (
  <Menu
    elevation={0}
    getContentAnchorEl={null}
    anchorOrigin={{
      vertical: 'center',
      horizontal: 'left',
    }}
    transformOrigin={{
      vertical: 'center',
      horizontal: 'right',
    }}
    {...props}
  />
));

const StyledMenuItem = withStyles((theme) => ({
  root: {
    '&:focus': {
      'backgroundColor': theme.palette.purple.light,
      '& .MuiListItemIcon-root, & .MuiListItemText-primary': {
        color: theme.palette.common.white,
      },
    },
  },
}))(MenuItem);

function DependentRow({ dependent, setDependentDelete, setManageDependentPackages}) {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <TableRow key={dependent.id}>
      <TableCell>
        <Avatar src={`${URL}/public/user_face/${dependent.uuid}.png?size=36`} />
      </TableCell>
      <TableCell>
        <Link variant="body2" href={showPerson.reverse({id: dependent.id})}>
          <Typography>{ dependent.name}</Typography>
        </Link>
      </TableCell>
      <TableCell align="center">
        <DependentPackages packages={dependent.package_users} />
      </TableCell>
      <TableCell align="right">
        <Can I="delete" a="Dependents">
          <IconButton onClick={handleClick} edge="end" aria-label="delete" >
            <SettingsIcon />
          </IconButton>
          <StyledMenu
            id="customized-menu"
            anchorEl={anchorEl}
            keepMounted
            open={Boolean(anchorEl)}
            onClose={handleClose}
          >
            <StyledMenuItem
              onClick={ () => {
                handleClose();
                setManageDependentPackages(dependent);
              }}
            >
              <ListItemIcon>
                <SendIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText primary="Gerenciar Adicionais" />
            </StyledMenuItem>
            <StyledMenuItem
              onClick={() => {
                handleClose();
                setDependentDelete(dependent);
              } }
            >
              <ListItemIcon>
                <DeleteIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText primary="Excluir" />
            </StyledMenuItem>
          </StyledMenu>
        </Can>
      </TableCell>
    </TableRow>
  );
}

DependentRow.propTypes={
  setDependentDelete: PropTypes.func.isRequired,
  setManageDependentPackages: PropTypes.func.isRequired,
  user: PropTypes.object
};

export default React.memo(DependentRow);
